<template>
  <el-select
    :value="localValue"
    :size="size"
    :multiple="multiple"
    :disabled="disabled"
    clearable
    :placeholder="placeholder"
    @change="selected"
  >
    <el-option
      v-for="(periodName, periodLength) in $companyConfiguration.card.getAvailablePeriods()"
      :key="periodLength"
      :label="periodName"
      :value="periodLength"
    >
    </el-option>
  </el-select>

</template>

<script>

export default {
  name: "cards-period-select",
  components: {},
  props: {
    value: {},
    size: {type: String, default: '' },
    disabled: {type: Boolean, default: false },
    multiple: {type: Boolean, default: true },
    placeholder: {type: String, default: 'Период' },
  },

  data() {
    return {
      localValue: this.value,
    }
  },
  mounted() {
  },
  watch: {
    value(newValue){
      this.localValue = newValue;
    }
  },
  computed: {},
  methods: {
    selected(value) {
      this.localValue = value;
      this.$emit('input', value);
      this.$emit('change', value);
    }
  },

}
</script>

<style scoped>

</style>